// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__6RRdP","productName":"Table_productName__1Big-"};